export default "__VITE_ASSET__fbbdbe5d__"